// extracted by mini-css-extract-plugin
export var cols = "styles-module--cols--BoAaH";
export var container = "styles-module--container--cOS6j";
export var wrapper = "styles-module--wrapper--kHzOr";